/* eslint-disable @typescript-eslint/no-explicit-any */

import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { LoaderCircle, Trash2Icon } from "lucide-react";
import { useEditTable } from "../react-hook/use-edit-table";
import { ServerSelect } from "../user-input/server-select";

type UserFormType = {
  data: any;
  retailerList: any;
  onOpenChange: (prop: any) => void;
  onFormSubmit: (prop: boolean) => Promise<void>;
  open: boolean;
};

export const ReactEditTable = ({
  data,
  onOpenChange,
  retailerList,
  onFormSubmit,
}: UserFormType) => {
  const { manageRetailer, retailers, onSelect, loader, onSubmitHandler } =
    useEditTable({
      list: data,
      onFormSubmit,
    });
  return (
    <div>
      <div className="h-screen md:h-[calc(100dvh-420px)] overflow-y-auto  ">
        <Table style={{ borderCollapse: "collapse", width: "100%" }}>
          <TableHeader className="sticky top-0 z-[2]">
            <TableRow>
              <TableHead className="pl-5">Retailers Name</TableHead>
              <TableHead>Is Primary</TableHead>
              <TableHead className="text-center sticky right-0 z-[2] w-auto pr-0">
                <div className="flex justify-end">
                  <div className="w-[66px] md:w-[135px] text-left pl-[8px]">
                    Actions
                  </div>
                </div>
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {retailers.map((row: any, rowIndex: number) => {
              console.log({ row });
              return (
                <TableRow key={rowIndex}>
                  <TableCell isLineClampDisable={true} className="pl-5">
                    {row.retailer_name}
                  </TableCell>
                  <TableCell
                    isLineClampDisable={true}
                    className="pl-2 w-[100px]"
                  >
                    {row.is_primary}
                    <Switch
                      checked={row.is_primary}
                      disabled={row.is_primary}
                      onCheckedChange={(prop) => {
                        manageRetailer({
                          data: { id: row.retailer_id, value: prop },
                          action: "update",
                        });
                      }}
                    />
                  </TableCell>
                  <TableCell
                    className="text-right sticky right-0  bg-white w-[100px]"
                    nestedClassName="pr-0"
                  >
                    <div className="flex items-center justify-end z-[2] bg-white">
                      <div className="flex items-center w-[66px] md:w-[135px]">
                        <TooltipProvider>
                          <Tooltip>
                            <TooltipTrigger asChild>
                              <Button
                                variant={"ghost"}
                                size={"icon"}
                                className="text-red-500"
                                disabled={row.is_primary}
                                onClick={() =>
                                  manageRetailer({
                                    data: { id: row.retailer_id },
                                    action: "delete",
                                  })
                                }
                              >
                                <Trash2Icon />
                              </Button>
                            </TooltipTrigger>

                            <TooltipContent>
                              <p>Delete</p>
                              <TooltipArrow />
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
      <div className=" border border-l-0 border-r-0 px-5 py-5 ">
        <ServerSelect
          retailerList={retailerList}
          list={retailers.map((item: any) => item.retailer_id)}
          onSelect={onSelect}
        />
      </div>

      <div className="flex justify-start px-5 py-5 gap-4">
        <Button
          className="w-[120px]"
          disabled={loader || retailers.length < 2}
          onClick={onSubmitHandler}
        >
          {loader ? <LoaderCircle className="animate-spin" /> : "Save"}
        </Button>
        <Button
          variant={"outline"}
          className="w-[120px]"
          onClick={() => onOpenChange(false)}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};
